import React from "react";
import { useHistory, useLocation } from "react-router";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";

const TITLE = {
  "/": "",
  "/no-account": "",
  "/login": "Log In",
  "/forgot-password": "Forgot Password",
  "/signup": "Sign Up",
  "/account-info": "Account Info",
  "/payment-info": "Payment Info",
};

const AuthHeader = ({ className }) => {
  const location = useLocation();
  const { pathname } = location;
  const { goBack } = useHistory();
  if (pathname === "/") return null;
  return (
    <h1 className={`auth-header ${className || ""}`}>
      <Icon
        icon={["far", "arrow-left"]}
        className="back-icon"
        onClick={goBack}
      />{" "}
      {TITLE[pathname]}
    </h1>
  );
};

export default AuthHeader;
